<template>
	<button
		ref="btnRef"
		v-click-away="closeTooltip"
		type="button"
		class="inline-flex items-center rounded-full text-gray-300 focus:text-secondary hover:text-secondary focus:outline-none ease-linear transition-all duration-150"
	>
		<QuestionMarkCircleIcon
			class="h-5 w-5"
			aria-hidden="true"
			type="button"
			@mouseenter="openTooltip()"
		/>
	</button>
	<div
		ref="tooltipRef"
		:class="{ hidden: !tooltipShow, block: tooltipShow }"
		class="bg-white border border-gray-200 shadow-sm offset block z-10 font-normal leading-normal text-sm max-w-xs text-left no-underline break-words rounded-lg"
	>
		<div>
			<div class="text-gray-500 p-3 text-xs" v-html="tooltipMessage"></div>
		</div>
	</div>
</template>

<script>
import { mixin as VueClickAway } from 'vue3-click-away'
import { ref } from 'vue'
import { createPopper } from '@popperjs/core'
import { QuestionMarkCircleIcon } from '@heroicons/vue/solid'
export default {
	components: {
		QuestionMarkCircleIcon,
	},
	mixins: [VueClickAway],
	props: {
		tooltipMessage: {
			type: String,
			required: false,
			default: '',
		},
	},
	setup() {
		let tooltipShow = ref(false)
		const btnRef = ref(null)
		const tooltipRef = ref(null)

		function openTooltip() {
			tooltipShow.value = true
			createPopper(btnRef.value, tooltipRef.value, {
				placement: 'bottom',
			})
		}

		function closeTooltip(event) {
			tooltipShow.value = false
		}

		return {
			tooltipShow,
			openTooltip,
			closeTooltip,
			btnRef,
			tooltipRef,
		}
	},
}
</script>
